// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"141":"90877f29","449":"61a43bb7","451":"3b93cebc","469":"f84e4f3d","495":"4b4f010f","628":"be4eb84b","657":"9df79f67","731":"f5ee217d"}[chunkId] + ".js";
};